<form [formGroup]="formGroup" (submit)="submit()">
  <div class="mt-3">
    <nx-formfield>
      <nx-formfield-label>
        <div class="flex">
          <span> {{ 'esg-gerl.escalation-quiz' | translate }}</span>
          @if (loading) {
            <nx-spinner class="ml-2 self-center" />
          }
        </div>
      </nx-formfield-label>
      <textarea nxInput rows="6" spellcheck="false" formControlName="esgGerlQuizComment" type="text"></textarea>
    </nx-formfield>
  </div>
  <div class="flex justify-end mt-3">
    <button type="submit" [disabled]="formGroup.invalid || loading" nxButton="small-medium">
      @if (loading) {
        <nx-spinner />
      } @else {
        {{ 'esg.quiz.buttons.save' | translate }}
      }
    </button>
  </div>
</form>
